import { render, staticRenderFns } from "./SpaceMembers.vue?vue&type=template&id=55c0634c&"
import script from "./SpaceMembers.vue?vue&type=script&lang=js&"
export * from "./SpaceMembers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports